// Policy Page Class
document
  .querySelectorAll(".shopify-policy__container")
  .forEach(function (element) {
    element.classList.add("container");
  });

// Swiper Reel
var swiper = new Swiper(".reelSwiper", {
  slidesPerView: 2.5,
  spaceBetween: 10,
  disableOnInteraction: true,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
  autoplay: {
    delay: 10000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 4.3,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 5.3,
      spaceBetween: 15,
    },
  },
});

// Testimonial Swiper
var swiperTestimonial = new Swiper(".testimonialSwiper", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

// Count
function makeTimer() {
  var endTime = new Date("22 February 2025 9:56:00 GMT+01:00");
  endTime = Math.floor(Date.parse(endTime) / 1000);

  var now = new Date();
  now = Math.floor(Date.parse(now) / 1000);

  var timeLeft = endTime - now;

  var days = Math.floor(timeLeft / 86400);
  var hours = Math.floor((timeLeft - days * 86400) / 3600);
  var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
  var seconds = Math.floor(
    timeLeft - days * 86400 - hours * 3600 - minutes * 60
  );

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  document.getElementById("days").innerHTML = days + "<span>Days</span>";
  document.getElementById("hours").innerHTML = hours + "<span>Hours</span>";
  document.getElementById("minutes").innerHTML =
    minutes + "<span>Minutes</span>";
  document.getElementById("seconds").innerHTML =
    seconds + "<span>Seconds</span>";
}

setInterval(makeTimer, 1000);

// Happy Customer
let count = 0;
const target = 500000;
const speed = 3.5; // speed in ms

function updateCounter() {
  if (count < target) {
    count += 50; // increase faster
    if (count > target) count = target;
    document.getElementById("counter").innerText = count.toLocaleString();
    setTimeout(updateCounter, speed);
  }
}

updateCounter();

document.querySelectorAll('.testimonial-content .content').forEach(function (element) {
    element.addEventListener('click', function () {
        window.location.href = 'https://zudieo.com/products/magic-stain-remover'; 
    });
}); 


// snow Flakes

const snowContainer = document.querySelector('.snow-container');

function createSnowflakes(num) {
 for (let i = 0; i < num; i++) {
 const snowflake = document.createElement('div');
 snowflake.classList.add('snowflake');

 // Set random size
 const size = Math.random() * 10 + 8; // size between 10px to 30px
 snowflake.style.fontSize = `${size}px`;

 // Set random position
 const leftPosition = Math.random() * 100; // random horizontal position
 snowflake.style.left = `${leftPosition}vw`;

 // Set random animation duration
 const speed = Math.random() * 10 + 5; // speed between 3s to 8s
 snowflake.style.animationDuration = `${speed}s`;

 // Set random horizontal movement
 const horizontalMovement = (Math.random() - 0.5) * 50; // random horizontal movement
 snowflake.style.transform = `translateX(${horizontalMovement}px)`;

 // Set the snowflake character
 snowflake.innerHTML = '&#10052;';

 // Set random color for the snowflake
 snowflake.style.color = `hsl(${Math.random() * 360}, 100%, 100%)`; // Random color in HSL range

 snowContainer.appendChild(snowflake);

 // Remove snowflakes after it falls
 snowflake.addEventListener('animationend', () => {
 snowflake.remove();
 });
 }
}

// Set the amount of snow
const amountSnow = 20; // amount of snow

// Create snow
createSnowflakes(amountSnow);

// Create new snow every second
setInterval(() => {
createSnowflakes(1);
}, 2000);
